<template>
  <v-container fluid class="mt-5">
    <v-row class="mb-8 titulo">
      <v-col>
        <h2>Dashboard de Faturamento</h2>
      </v-col>
    </v-row>

    <v-card class="mt-0 mb-5 elevation-0" :disabled="loadingDados">
    <v-tabs v-model="tab" fixed-tabs color="primary">
      <v-tab>
        Geral
      </v-tab>
      <v-tab>
        Visão Aneel
      </v-tab>
      <v-tab>
        Municípios
      </v-tab>
    </v-tabs>

      <v-card-title>
        <h4>Parâmetros</h4>
      </v-card-title>
      <v-card-text>
        <v-row class="mx-auto mt-3" justify="space-between">
          <v-col v-if="tab === 0" cols="12" sm="6">
            <div class="text-h6 grey--text mb-2 body-2">
              Período de Competência
            </div>
            <div class="d-flex align-center">
              <input-month
                rules="min:7"
                :minMonth="'2023-01'"
                :selectedMonth="competenciaDe"
                @monthSelected="setCompetenciaDe"
                outlined
                dense
                class="mr-2"
              />
              <span class="mx-2 grey--text body-2">até</span>
              <input-month
                rules="min:7"
                :minMonth="'2023-01'"
                :selectedMonth="competenciaAte"
                @monthSelected="setCompetenciaAte"
                outlined
                dense
              />
            </div>
          </v-col>
          <v-col v-if="tab !== 0" cols="12">
            <v-row align="end" no-gutters>
              <v-col cols="auto" class="mr-4">
                <div class="text-h6 grey--text mb-2 body-2">
                  Competência
                </div>
                <input-month
                  rules="min:7"
                  :minMonth="'2023-01'"
                  :selectedMonth="competencia"
                  @monthSelected="setCompetencia"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="auto">
                <div class="text-h6 grey--text mb-2 body-2">
                  Regional selecionada
                </div>
                <v-select
                  :items="regionaisList"
                  :value="regionalSelecionada"
                  @change="setRegionalSelecionada"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="auto" class="ml-auto">
                <v-btn color="primary" @click="dialogMetasKpis = true">
                  Gerenciar metas dos KPIs
                  <v-icon class="ml-2">
                    mdi-open-in-app
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="tab === 2" class="mx-auto" justify="space-between">
          <v-col cols="12" sm="5" md="3">
            <div class="text-h6 grey--text mb-2 body-2">
              Município selecionado
            </div>
            <v-autocomplete
              :items="municipios"
              v-model="municipioSelecionado"
              clearable
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" sm="5" md="3">
            <div class="text-h6 grey--text mb-2 body-2">
              Ordem Gráficos
            </div>
            <v-select
              :items="listaKpisOrdenacao"
              :value="kpiOrdenacao"
              @change="setKpiOrdenacao"
              outlined
              dense
              :append-icon="iconTipoOrdenacao"
              @click:append="
                tipoOrdenacao === 'asc'
                  ? (tipoOrdenacao = 'desc')
                  : (tipoOrdenacao = 'asc')
              "
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-progress-linear
        v-if="loadingDados"
        color="primary"
        indeterminate
        height="4"
        class="my-0"
      />
    </v-card>

    <dashboard-faturamento-geral
      v-if="tab === 0 && competenciaDe != '' && competenciaAte != ''"
      :activatedTab="tab"
      :traducaoIndicadores="traducaoIndicadores"
      @updateLoadingDados="loadingDados = $event"
      :competenciaDe="competenciaDe"
      :competenciaAte="competenciaAte"
    />

    <dashboard-faturamento-visao-aneel
      v-if="tab === 1 && competencia != ''"
      :competencia="competencia"
      :categories="categories"
      :activatedTab="tab"
      :traducaoIndicadores="traducaoIndicadores"
      @updateLoadingDados="loadingDados = $event"
      :regionalSelecionada="regionalSelecionadaId"
    />

    <dashboard-faturamento-visao-municipios
      v-if="tab === 2 && competencia != ''"
      :competencia="competencia"
      :categories="categories"
      :municipios="municipios"
      :municipioSelecionado="municipioSelecionado"
      :tipoOrdenacao="tipoOrdenacao"
      :kpiOrdenacao="kpiOrdenacao"
      :activatedTab="tab"
      :traducaoIndicadores="traducaoIndicadores"
      :regionalSelecionada="regionalSelecionadaId"
      @updateLoadingDados="loadingDados = $event"
    />

    <dialog-gerenciamento-metas-kpis
      v-if="dialogMetasKpis"
      :dialog.sync="dialogMetasKpis"
      ref="metasKpis"
      @importaMetasKpis="importaMetasKpis()"
      @baixarMetasKpis="baixarMetasKpis($event)"
    >
      <template v-slot:cadatro-geral-extra-info>
        Deve conter as colunas:
        <span class="font-weight-bold">mes; ano; psl; prf; pcf</span>
      </template>
      <template v-slot:cadatro-municipios-extra-info>
        Deve conter as colunas:
        <span class="font-weight-bold"
          >codigo_municipio; mes; ano; psl; prf; pcf</span
        >
      </template>
    </dialog-gerenciamento-metas-kpis>
  </v-container>
</template>

<script>
import { generateMonthlyDateRangeArray } from "@/utils/dateUtils.js";

import dayjs from "dayjs";

import MunicipiosService from "@/services/MunicipiosService";
import DashboardFaturamentoService from "@/services/DashboardFaturamentoService";
import { mapActions, mapState } from "vuex";

export default {
  name: "DashboardFaturamento",
  components: {
    InputMonth: () => import("@/components/general/InputMonth.vue"),
    DashboardFaturamentoGeral: () =>
      import("@/components/dashboardFaturamento/DashboardFaturamentoGeral.vue"),
    DashboardFaturamentoVisaoAneel: () =>
      import(
        "@/components/dashboardFaturamento/DashboardFaturamentoVisaoAneel.vue"
      ),
    DashboardFaturamentoVisaoMunicipios: () =>
      import(
        "@/components/dashboardFaturamento/DashboardFaturamentoVisaoMunicipios.vue"
      ),
    DialogGerenciamentoMetasKpis: () =>
      import("@/components/paineisGerenciais/DialogGerenciamentoMetasKpis.vue"),
  },
  data: () => ({
    tab: 1,
    loadingDados: true,
    dialogMetasKpis: false,
    municipios: [],
    regionais: [],
    listaKpisOrdenacao: [
      { text: "PSL", value: "psl" },
      { text: "PRF", value: "prf" },
      { text: "PCF", value: "pcf" },
    ],
    tipoOrdenacao: "desc",
    traducaoIndicadores: {
      psl: "Percentual de Faturas Emitidas Sem Leitura",
      prf: "Percentual de Refaturamentos",
      pcf: "Percentual de Acertos de Faturamento",
    },
  }),
  computed: {
    ...mapState("parametrosDashboardFaturamento", [
      "competenciaDe",
      "competenciaAte",
      "competencia",
      "regionalSelecionada",
      "municipio",
      "kpiOrdenacao",
    ]),
    municipioSelecionado: {
      get() {
        return this.municipio;
      },
      set(newValue) {
        this.setMunicipio(newValue);
      },
    },
    regionaisList() {
      return this.regionais.map((el) => el.nome);
    },
    categories() {
      const startDate = "2023-01";
      const endDate = dayjs().format("YYYY-MM");

      return generateMonthlyDateRangeArray(startDate, endDate, "YYYY-MM");
    },
    regionalSelecionadaId() {
      let regional = this.regionais.find(
        (element) => element.nome == this.regionalSelecionada,
      );
      return regional == undefined ? 0 : regional.id;
    },
    iconTipoOrdenacao() {
      if (this.tipoOrdenacao === "asc") return "mdi-sort-reverse-variant";
      else if (this.tipoOrdenacao === "desc") return "mdi-sort-variant";
    },
  },
  beforeMount() {
    this.setRangeCompetencias();
    // Garante que o kpiOrdenacao seja inicializado com 'psl' se estiver vazio
    if (!this.kpiOrdenacao) {
      this.setKpiOrdenacao("psl");
    }
  },
  async created() {
    await this.getRegionais();
    this.getMunicipiosByRegional();
  },
  methods: {
    ...mapActions("parametrosDashboardFaturamento", [
      "setRangeCompetencias",
      "setCompetenciaDe",
      "setCompetenciaAte",
      "setCompetencia",
      "setRegionalSelecionada",
      "setMunicipio",
      "setKpiOrdenacao",
    ]),
    getMunicipiosByRegional() {
      return MunicipiosService.getMunicipiosByRegional(
        this.regionalSelecionadaId,
      )
        .then((res) => {
          this.municipios = res.map((el) => el.nome_municipio);
        })
        .catch((err) => {
          this.$toast.error("Erro ao recuperar municípios.", "", {
            position: "topRight",
          });
          throw err;
        });
    },
    importaMetasKpis() {
      const ref = this.$refs.metasKpis;

      ref.loading = true;

      DashboardFaturamentoService.importarMetasKpis(
        ref.tipoDeCadastro,
        ref.lastUploadedFile.id,
      )
        .then((res) => {
          this.$toast.success("Metas salvas com sucesso", "", {
            position: "topRight",
          });
          ref.uploadedFiles = [];
          ref.dialogLocal = false;
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("Erro ao salvar metas", "", {
            position: "topRight",
          });
        })
        .finally(() => (ref.loading = false));
    },
    baixarMetasKpis(tipoDeCadastro) {
      const ref = this.$refs.metasKpis;

      ref.loading = true;

      DashboardFaturamentoService.baixarMetasKpis(tipoDeCadastro, {
        timeout: 60 * 60 * 1000,
      })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Metas dos KPIs - ${tipoDeCadastro}.xlsx`,
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("Erro ao baixar Metas dos KPIs", "", {
            position: "topRight",
          });
        })
        .finally(() => (ref.loading = false));
    },
    getRegionais() {
      return MunicipiosService.getRegionais()
        .then((res) => {
          this.regionais = res;
          if (this.regionalSelecionada == null) {
            this.setRegionalSelecionada(
              res.find((el) => el.nome.toLowerCase() == "distribuidora").nome,
            );
          }
        })
        .catch((err) => {
          throw err;
        });
    },
  },
  watch: {
    regionalSelecionada() {
      this.municipioSelecionado = null;
      this.getMunicipiosByRegional();
    },
  },
};
</script>

<style>
.titulo {
  font-family: "styrene A";
  font-weight: 500;
  color: #3c4858 !important;
  font-size: 18px !important;
}
</style>
